'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _epochToDate = require('./epochToDate');

var _epochToDate2 = _interopRequireDefault(_epochToDate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (epoch) {
    return (0, _epochToDate2.default)(epoch).toUTCString();
};


//////////////////
// WEBPACK FOOTER
// ./~/binary-utils/lib/date/epochToDateTimeString.js
// module id = 58
// module chunks = 0